// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"no-z","imageAndVideoCount":"oo-z","imageAndVideoContainer":"po-z","viewAllReviews":"qo-z"};